module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.hideBlock
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "profile-head"
  }, [_c('div', {
    staticClass: "profile-top",
    style: ({
      backgroundImage: 'url(' + _vm.userDetail.coverImage + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-bottom"
  }, [_c('div', {
    staticClass: "user-image text-xs-center mb-3"
  }, [_c('Tooltip', {
    attrs: {
      "content": '@' + _vm.userDetail.userName,
      "placement": "right-end"
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": "primary pointer",
      "size": "100"
    },
    on: {
      "click": function($event) {
        return _vm.openNewWindowViewImage(_vm.userDetail.image)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image != null),
      expression: "userDetail.image != null"
    }],
    attrs: {
      "src": _vm.userDetail.image,
      "alt": _vm.userDetail.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image == null),
      expression: "userDetail.image == null"
    }],
    staticClass: "font-50 white--text"
  }, [_vm._v("\n                                                    " + _vm._s(_vm.userDetail.userName != null ? _vm.userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                                ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "user-list-content mb-5"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('h3', {
    staticClass: "fw-700"
  }, [_vm._v(_vm._s(_vm.userDetail.nickName) + " (" + _vm._s(_vm.userDetail.reputationScore) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "font-16 fw-500 mt-3"
  }, [_c('span', {
    staticClass: "mx-3"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-at")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.userDetail.userName))])], 1), _vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-calendar-alt")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.regTimeFormat(_vm.userDetail.regTime)))])], 1)]), _vm._v(" "), (_vm.username != this.$store.state.user.name) ? _c('div', {
    staticClass: "social-list clearfix mb-4"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": _vm.follow
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFollow),
      expression: "!isFollow"
    }]
  }, [_c('Icon', {
    attrs: {
      "type": "plus-round",
      "color": "#FFFFFF"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("common.follow")))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFollow),
      expression: "isFollow"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("common.unfollow")))])])])], 1) : _vm._e()])])])])])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-5": "",
      "mb-5": "",
      "pb-5": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md3": "",
      "lg3": "",
      "xl2": ""
    }
  }, [_c('div', {
    staticClass: "inbox-head"
  }, [_c('div', {
    staticClass: "mailbox-items-warp"
  }, [_c('div', {
    staticClass: "app-card"
  }, [_c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.getMenuData('wallet')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fas fa-wallet")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                                        " + _vm._s(_vm.$t("wallet.wallet")) + "\n                                                    ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.getMenuData('transactionRecord')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fas fa-list-alt")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                                        " + _vm._s(_vm.$t("wallet.transactionRecord")) + "\n                                                    ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.getMenuData('investmentRecord')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fas fa-th-list")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                                        " + _vm._s(_vm.$t("wallet.investmentRecord")) + "\n                                                    ")])], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "inbox-content",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('div', {
    staticClass: "inbox-content-wrap"
  }, [_c('v-card', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowWallet),
      expression: "isShowWallet"
    }],
    staticClass: "ml-3 mr-3 mb-5"
  }, [_c('h2', {
    staticClass: "fw-700 mb-5"
  }, [_vm._v(_vm._s(_vm.$t("wallet.wallet")))]), _vm._v(" "), (_vm.userDetail.walletAddress != null && _vm.userDetail.walletAddress != '') ? _c('div', [_c('Row', [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t("wallet.walletAddress")))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_vm._v("\n                                                    " + _vm._s(_vm.userDetail.walletAddress) + "\n                                                ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t("wallet.balance")))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_vm._v("\n                                                    " + _vm._s(_vm.balance / 1000000000000000000) + " IOB (" + _vm._s(_vm.$t("wallet.decimals")) + ": 18)\n                                                ")])], 1)], 1) : _c('div', [_vm._v("\n                                            " + _vm._s(_vm.$t("wallet.walletSetMessage")) + "\n                                            "), _c('br'), _c('br'), _vm._v(" "), _c('Form', {
    ref: "formWallet",
    attrs: {
      "model": _vm.formWallet,
      "rules": _vm.ruleWallet
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "walletAddress"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.formWallet.walletAddress),
      callback: function($$v) {
        _vm.$set(_vm.formWallet, "walletAddress", $$v)
      },
      expression: "formWallet.walletAddress"
    }
  }), _vm._v("   \n                                                "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#41B8BC",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showConfirmWalletModal('formWallet')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.confirm")))])], 1)], 1)], 1)]), _vm._v(" "), _c('div', [_c('Modal', {
    model: {
      value: (_vm.isShowConfirmWalletModal),
      callback: function($$v) {
        _vm.isShowConfirmWalletModal = $$v
      },
      expression: "isShowConfirmWalletModal"
    }
  }, [_c('div', {
    staticClass: "body-2 text-center"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("wallet.confirmWalletHint")))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.formWallet.walletAddress))])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('Button', {
    staticClass: "text-white primary",
    on: {
      "click": function($event) {
        return _vm.showConfirmWalletModal('formWallet')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('Button', {
    staticClass: "text-white primary",
    on: {
      "click": function($event) {
        return _vm.updateWallet('formWallet')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.submit")))])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowTransactionRecord),
      expression: "isShowTransactionRecord"
    }]
  }, [_c('h2', {
    staticClass: "fw-bold mb-5"
  }, [_vm._v(_vm._s(_vm.$t("wallet.transactionRecord")))]), _vm._v(" "), (_vm.userDetail.walletAddress != null && _vm.userDetail.walletAddress != '') ? _c('div', [_c('v-data-table', {
    staticClass: "elevation-1 mb-5",
    attrs: {
      "headers": _vm.transactionTableHeaders,
      "items": _vm.transactionList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "primary--text pointer",
          attrs: {
            "title": _vm.$t('common.details')
          },
          on: {
            "click": function($event) {
              return _vm.goTransactionData(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
          staticClass: "primary--text pointer",
          attrs: {
            "title": _vm.$t('common.details')
          },
          on: {
            "click": function($event) {
              return _vm.goTransactionData(props.item)
            }
          }
        }, [_vm._v(_vm._s((props.item.hash.length) > 18 ? (props.item.hash).substring(0, 18) + '...' : (props.item.hash)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getQuantity(props.item.input)))])]
      }
    }], null, false, 1815811248)
  })], 1) : _c('div', [_vm._v("\n                                            " + _vm._s(_vm.$t("wallet.setWalletMessage")) + "\n                                        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowInvestmentRecord),
      expression: "isShowInvestmentRecord"
    }]
  }, [_c('h2', {
    staticClass: "fw-bold mb-3"
  }, [_vm._v(_vm._s(_vm.$t("wallet.investmentRecord")))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "lg4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.queryFieldSelect,
      "item-text": "label",
      "item-value": "value",
      "required": ""
    },
    on: {
      "input": _vm.getInvestment
    },
    model: {
      value: (_vm.queryField),
      callback: function($$v) {
        _vm.queryField = $$v
      },
      expression: "queryField"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investmentList.length <= 0),
      expression: "investmentList.length <= 0"
    }]
  }, [_c('v-flex', [_vm._v(_vm._s(_vm.$t("wallet.noInvestmentMessage")))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investmentList.length > 0),
      expression: "investmentList.length > 0"
    }]
  }, [_c('v-data-table', {
    staticClass: "elevation-1 mb-5",
    attrs: {
      "headers": _vm.investmentTableHeaders,
      "items": _vm.investmentList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "primary--text pointer",
          attrs: {
            "title": _vm.$t('common.details')
          },
          on: {
            "click": function($event) {
              return _vm.goInvestmentData(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
          staticClass: "primary--text pointer",
          attrs: {
            "title": _vm.$t('common.details')
          },
          on: {
            "click": function($event) {
              return _vm.goInvestmentData(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.sentTime))]), _vm._v(" "), _c('td', {
          staticClass: "primary--text pointer",
          attrs: {
            "title": _vm.$t('common.details')
          },
          on: {
            "click": function($event) {
              return _vm.goInvestmentData(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.purchasingAmount))]), _vm._v(" "), _c('td', {
          staticClass: "primary--text pointer",
          attrs: {
            "title": _vm.$t('common.details')
          },
          on: {
            "click": function($event) {
              return _vm.goInvestmentData(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.paymentType))]), _vm._v(" "), _c('td', {
          staticClass: "primary--text pointer",
          attrs: {
            "title": _vm.$t('common.details')
          },
          on: {
            "click": function($event) {
              return _vm.goInvestmentData(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.totalIOB))])]
      }
    }])
  })], 1)], 1)])], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47409d96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/UserWallet.vue
// module id = 436
// module chunks = 0